import none from '../../img/kandokLogo.jpg'
export const kabab =[
 {
  "id": 11,
  "title": "وزیری",
  "desciption": "1سیخ لقمه 180 گرمی مخلوط گوشت گوساله و گوسفندی، 1 سیخ جوجه کباب بی استخوان 150 گرمی",
  "price": 290,
  "image": none
 },
 {
  "id": 12,
  "title": "بناب",
  "desciption": "300گرم مخلوط گوشت گوساله و گوسفندی",
  "price": 200,
  "image": none
 },
 {
  "id": 13,
  "title": "جوجه کباب با استخوان",
  "desciption": "700گرم جوجه کامل طعم دار شده زعفرانی",
  "price": 190,
  "image": none
 },
 {
  "id": 14,
  "title": "لقمه مخصوص",
  "desciption": "200گرم مخلوط گوشت گوساله و گوسفندی",
  "price": 185,
  "image": none
 },
 {
  "id": 15,
  "title": "لقمه نگین دار",
  "desciption": "180گرم مخلوط گوساله و گوسفندی، به همراه تکه های مرغ چسبیده",
  "price": 175,
  "image": none
 },
 {
  "id": 16,
  "title": "جوجه کباب بی استخوان مخصوص",
  "desciption": "220گرم سینه مرغ طمعه دار شده زعفرانی",
  "price": 165,
  "image": none
 },
 {
  "id": 17,
  "title": "لقمه معمولی",
  "desciption": "160گرم مخلوط گوشت گوساله و گوسفندی",
  "price": 150,
  "image": none
 }
]